import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FloatingButtons } from './FloatingButtons';

export const ShiftDetailsSkeleton = () => (
  <Box sx={{ pb: 10 }}>
    <Skeleton
      data-testid="shift-details-summary-skeleton"
      height={120}
      sx={{ mb: 4 }}
    />
    <Skeleton data-testid="shift-timeline-skeleton" height={320} />
    <FloatingButtons />
  </Box>
);
